const ACCESS_TOKEN_KEY =
  "197f28b41e62682b976aa71d0da04304b709004290c59ea0d1457187e65e96c336780c36dec6da1c376f84e8a671d6b991d80c0d8608209548132d3b25582e9f";
const REFRESH_TOKEN_KEY =
  "05d26ec101e50bf966e59bd012bd3c7567033df862f7c96d1f64fea310c5a7aff1fb16850cd392c8c92b60014799c6663cb5de309b3f5a005bcaee122022abf8";
const USER_KEY = "power_user";

/**
 * SAFE JSON PARSE
 */
function safeParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

/**
 * TOKEN STORAGE
 */
export const tokenStorage = {
  /**
   * SAVE FULL AUTH SESSION
   */
  saveAuth({ accessToken, refreshToken, user }) {
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    }

    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }

    /**
     * IMPORTANT:
     * SAVE ONLY SAFE USER DATA
     */
    if (user) {
      const safeUser = {
        _id: user._id || user.id || null,

        first_name: user.first_name || "",

        last_name: user.last_name || "",

        email: user.email || "",

        role: user.role || "",

        permissions: user.permissions || [],
      };

      localStorage.setItem(USER_KEY, JSON.stringify(safeUser));
    }
  },

  /**
   * UPDATE TOKENS ONLY
   *
   * USED DURING REFRESH FLOW
   */
  updateTokens({ accessToken, refreshToken }) {
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    }

    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }
  },

  /**
   * ACCESS TOKEN
   */
  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  /**
   * REFRESH TOKEN
   */
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  /**
   * USER
   */
  getUser() {
    const rawUser = localStorage.getItem(USER_KEY);

    if (!rawUser) {
      return null;
    }

    return safeParse(rawUser);
  },

  /**
   * HAS ACTIVE SESSION
   */
  hasSession() {
    const accessToken = this.getAccessToken();

    const refreshToken = this.getRefreshToken();

    return !!(accessToken && refreshToken);
  },

  /**
   * CLEAR SESSION
   */
  clearAuth() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);

    localStorage.removeItem(REFRESH_TOKEN_KEY);

    localStorage.removeItem(USER_KEY);
  },
};

export default tokenStorage;
